import { CancellationToken } from '@cian/http-api';

export function getCancellationTokenFromSignal(signal: AbortSignal | undefined | null): CancellationToken {
  const cancellationToken = new CancellationToken();

  if (signal) {
    signal.onabort = (): void => {
      cancellationToken.cancel();
    };
  }

  return cancellationToken;
}
